//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StockKittingToolReserve from '../StockTools/StockKittingToolReserve.vue'
import TableServer from '../../components/Table/Table.vue'

export default {
  components: {
    StockKittingToolReserve,
    TableServer
  },
  props: {
    stock: {
      type: Object,
      default: null
    },
    manager: {
      type: Object,
      required: true
    },
    request: {
      type: Object,
      default: null
    },
    excludedToolIds: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      tools: [],
      columns: [],
      selectedRecord: null
    }
  },
  computed: {
    isMobileDevice: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    additionalUrlParams: function () {
      if (this.stock || this.manager.targetStockId) {
        const params = {}
        if (this.stock) {
          params.stock = this.stock.key
        }
        if (this.manager.targetStockId != null) {
          params.targetId = this.manager.targetStockId
        }
        return params
      }
      return null
    }
  },
  created: function () {
    if (this.isMobileDevice) {
      this.columns = [{
        name: 'toolName',
        label: 'Наименование материала',
        align: 'center',
        field: 'tool',
        sortable: true
      }]
    } else {
      this.columns = [
        {
          name: 'toolName',
          label: 'Наименование материала',
          align: 'left',
          field: 'tool',
          sortable: true
        },
        // {
        //   name: 'stockName',
        //   label: 'Наименование склада',
        //   align: 'left',
        //   field: 'stockName',
        //   sortable: true
        // },
        {
          name: 'amountStock',
          label: 'Кол-во на складе',
          align: 'left',
          field: 'amountStock',
          sortable: true,
          format: value => {
            return value == null ? 'Отсутствует' : value
          }
        },
        {
          name: 'amountFree',
          label: 'Свободное кол-во',
          align: 'left',
          field: 'amountFree',
          sortable: true
        },
        {
          name: 'targetStockAmount',
          label: 'Текущий остаток на складе-получателе',
          align: 'left',
          field: 'targetStockAmount',
          sortable: true
        }
      ]

      if (this.request.stock && this.request.stock.id) {
        this.columns.push({
          name: 'otherAgreedRequests',
          label: 'Заказано по другим заявкам на выбранный склад-получатель',
          align: 'left',
          field: 'otherRequestsRecords',
          sortable: true
        })
      }
    }
  },
  methods: {
    isExcluded: function (record) {
      return this.excludedToolIds && this.excludedToolIds.includes(record.tool.id)
    },
    onSelectRecord: function (record) {
      if (record != null) {
        if (record.tool.id === (this.selectedRecord && this.selectedRecord.tool.id)) {
          this.selectedRecord._selected = false
          this.selectedRecord = null
        } else {
          if (this.selectedRecord) {
            this.selectedRecord._selected = false
          }
          this.selectedRecord = record
          this.$set(this.selectedRecord, '_selected', true)
        }
      } else {
        if (this.selectedRecord) {
          this.$set(this.selectedRecord, '_selected', false)
        }
        this.selectedRecord = null
      }
    },
    onApplySelection: function () {
      this.$emit('select', this.selectedRecord)
    },
    isInt: function (unit) {
      return ['упак', 'бут', 'пар', 'компл', 'рул', 'мешок', 'лист', 'усл. шт', 'шт'].includes(unit)
    },
    getTrClass: function (row) {
      const classes = []
      // if (row._selected) {
      //   classes.push('stock-kitting-tool-searcher__tr--selected')
      // }
      if (row.blocked) {
        classes.push('disabled')
        classes.push('bg-red-2')
      } else if (this.isExcluded(row)) {
        classes.push('disabled')
      } else {
        classes.push('cursor-pointer')

        if (row.amountStock == null && this.manager.ignoreLimits) {
          classes.push('bg-yellow-3')
        }
      }
      return classes
    }
  }
}
